import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HealthRule } from "models/health-rule";

export interface AdminProjectHealthRulesSliceState {
    rules: HealthRule[];
}

export const initialState: AdminProjectHealthRulesSliceState = {
    rules: [],
};

const AdminProjectHealthRulesSlice = createSlice({
    name: "admin-project-health-rules-slice",
    initialState,
    reducers: {
        setRules(state, { payload }: PayloadAction<HealthRule[]>) {
            state.rules = payload;
        },
        setRule(state, { payload }: PayloadAction<HealthRule>) {
            const index = state.rules.findIndex(r => r.key === payload.key);
            if (index !== -1) state.rules[index] = payload;
        },
    },
});

export const { setRules, setRule } = AdminProjectHealthRulesSlice.actions;

export default AdminProjectHealthRulesSlice.reducer;
